module.exports = "/_next/static/images/group-3-99d6d8d1.png";